import React from 'react';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import TopicTabs from '../components/TopicTabs';
import { useI18n } from '../i18n/I18nContext';
import styles from '../styles/Sourdough.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const Sourdough = () => {
  const { language, t } = useI18n();
  const title = t('pages.artisanBreads.sourdoughPageTitle');
  const intro = t('pages.artisanBreads.sourdoughPageIntro');
  const topics = [
    {
      id: 'overview',
      slug: { en: 'sourdough', de: 'sauerteig', bg: 'kvas' }[language],
      label: t('pages.artisanBreads.sourdoughTopics.overview'),
      src: `${publicUrl}/content/sourdough/${language}/why-sourdough-needs-time.md`,
    },
    {
      id: 'basics',
      slug: { en: 'what-is-sourdough', de: 'was-ist-sauerteig', bg: 'kakvo-e-kvas' }[language],
      label: t('pages.artisanBreads.sourdoughTopics.basics'),
      src: `${publicUrl}/content/sourdough/${language}/what-is-sourdough.md`,
    },
    {
      id: 'benefits',
      slug: { en: 'sourdough-benefits', de: 'sauerteig-vorteile', bg: 'predimstva-na-kvasa' }[language],
      label: t('pages.artisanBreads.sourdoughTopics.benefits'),
      src: `${publicUrl}/content/sourdough/${language}/sourdough-benefits.md`,
    },
    {
      id: 'process',
      slug: { en: 'from-starter-to-crust', de: 'vom-anstellgut-bis-zur-kruste', bg: 'ot-kvasa-do-korichkata' }[language],
      label: t('pages.artisanBreads.sourdoughTopics.process'),
      src: `${publicUrl}/content/sourdough/${language}/from-starter-to-crust.md`,
    },
  ];
  const meta = {
    title,
    description: intro,
    meta: {
      name: {
        description: intro,
        keywords: 'sourdough bread, sourdough starter, homemade bread, artisan bread, Grain Bites',
      },
    },
  };

  return (
    <DocumentMeta {...meta} extend>
      <main className={styles.page}>
        <header
          className={styles.hero}
          style={{ backgroundImage: `url(${publicUrl}/images/hero/artisan-bread-bg.webp)` }}
        >
          <p className={styles.label}>{t('pages.artisanBreads.sourdoughLabel')}</p>
          <h1>{title}</h1>
          <p>{intro}</p>
        </header>

        <article className={styles.article}>
          <TopicTabs
            tabs={topics}
            label={t('pages.artisanBreads.sourdoughTopicsLabel')}
            contentClassName={styles.markdown}
          />
        </article>

        <Link className={styles.back} to={`${publicUrl}/Artisan-Breads`}>
          {t('pages.artisanBreads.sourdoughBack')}
        </Link>
      </main>
    </DocumentMeta>
  );
};

export default Sourdough;
